import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Style1 from "../Assets/images/style1.jpg";
import Style2 from "../Assets/images/style2.jpeg";
import Style3 from "../Assets/images/style3.jpeg";
import Style4 from "../Assets/images/style4.jpeg";
import Style5 from "../Assets/images/style5.jpeg";
import Style6 from "../Assets/images/style6.jpeg";
import Style7 from "../Assets/images/style7.jpeg";
import diffusion from "../Assets/images/style8.jpeg";
import creature from "../Assets/images/style9.jpg";
import d_objects from "../Assets/images/3d-objects.jpeg";
import impressionism from "../Assets/images/impressionism.jpeg";
import contemporaryarchitecture from "../Assets/images/style11.jpeg";
import Style12 from "../Assets/images/style12.jpeg";
import Style13 from "../Assets/images/style13.jpeg";
import Style14 from "../Assets/images/style14.jpeg";
import colorizer from "../Assets/images/style15.png";
import dream from "../Assets/images/style16.png";
import fantasycharacter from "../Assets/images/fancyCaractor.jpeg";
import old_drawing from "../Assets/images/old-drawing.jpeg";
import cyberpunk from "../Assets/images/cyberpunk.jpeg";
import fantasy_world from "../Assets/images/fantasy-world.jpeg";
import anime_portrait from "../Assets/images/anime_portrait.jpeg";
import renaissance from "../Assets/images/renaissance.jpeg";
import abstract from "../Assets/images/abstract.jpeg";
import d_origami from "../Assets/images/3d-origami.jpeg";
import d_character from "../Assets/images/3d-character.jpeg";
import watercolor from "../Assets/images/watercolor.jpeg";
import pop_art from "../Assets/images/pop-art.jpeg";
import logo from "../Assets/images/logo.jpeg";
import pixel from "../Assets/images/pixel.jpeg";
import futurearchitecture from "../Assets/images/futurearchitecture.jpeg";

import { updateCategory } from "../redux/counterSlice";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function StyleModulePopup(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showHide, setShowHide] = useState(false);
  const dispatch = useDispatch();

  // const [dobjects, setDobjects] = useState(false)
  // const [pixel1, setPixel1] = useState(false)
  // const [watercolor1, setWatercolor1] = useState(false)
  // const [futurearchitecture, setFuturearchitecture] = useState(false)
  // const [fantasycharacter, setFantasycharacter] = useState(false)
  // const [Pixel2, setPixel2] = useState(false)
  // const [logo, setLogo] = useState(false)
  // const [streampunk, setStreampunk] = useState(false)
  // const [diffusion, setDiffusion] = useState(false)
  // const [creature, setCreature] = useState(false)
  // const [surreal, setSurreal] = useState(false)
  // const [fantasycharacter1, setfantasycharacter1] = useState(false)
  // const [watercolorArchitecture, setWatercolorArchitecture] = useState(false)
  // const [futurearchitecture2, setFuturearchitecture2] = useState(false)
  // const [contemporaryArchitecture, setContemporaryArchitecture] = useState(false)
  // const [future, setFuture] = useState(false)
  // const [paperart, setPaperart] = useState(false)
  // const [watercolor, setWatercolor] = useState(false)
  // const [dcharacter, setDcharacter] = useState(false)
  // const [dorigami, setDorigami] = useState(false)
  // const [dobject, setDobject] = useState(false)
  // const [impressionism, setImpressionism] = useState(false)
  // const [abstract, setAbstract] = useState(false)
  // const [renaissance, setRenaissance] = useState(false)
  // const [olddrawing, setOlddrawing] = useState(false)
  // const [animeportrait, setAnimeportrait] = useState(false)
  // const [cyberpunk, setCyberpunk] = useState(false)
  // const [fantasyworld, setFantasyworld] = useState(false)
  // const [dream, setDream] = useState(false)
  // const [colorizer, setColorizer] = useState(false)

  return (
    <div>
      {/* <!-- The Modal --> */}
      <div id="selectStyle">
        <ul className="styleImgSection" onClick={() => props.onHide()}>
          <li onClick={() => dispatch(updateCategory(0))}>
            <a href="#">
              <img src={Style1} />
              <p>steampunk</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(1))}>
            <a href="#">
              <img src={d_objects} />
              <p>3d-objects</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(2))}>
            <a href="#">
              <img src={pixel} />
              <p>pixel</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(3))}>
            <a href="#">
              <img src={watercolor} />
              <p>watercolor</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(4))}>
            <a href="#">
              <img src={futurearchitecture} />
              <p>future-architecture</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(5))}>
            <a href="#">
              <img src={fantasycharacter} />
              <p>fantasy-character</p>
            </a>
          </li>
          {/* <li onClick={() => dispatch(updateCategory(6))}>
                                                    <a href="#">
                                                        <img src={Style7} />
                                                        <p>Pixel</p>
                                                    </a>
                                                </li> */}
          <li onClick={() => dispatch(updateCategory(7))}>
            <a href="#">
              <img src={logo} />
              <p>Logo</p>
            </a>
          </li>
          {/* <li onClick={() => dispatch(updateCategory(8))}>
                                                    <a href="#">
                                                        <img src={Style1} />
                                                        <p>Streampunk</p>
                                                    </a>
                                                </li> */}

          <li onClick={() => dispatch(updateCategory(9))}>
            <a href="#">
              <img src={diffusion} />
              <p>diffusion</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(10))}>
            <a href="#">
              <img src={creature} />
              <p>creature</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(11))}>
            <a href="#">
              <img src={Style12} />
              <p>surreal</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(12))}>
            <a href="#">
              <img src={Style13} />
              <p>fantasy-character</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(13))}>
            <a href="#">
              <img src={Style14} />
              <p>watercolor-architecture</p>
            </a>
          </li>
          {/* <li onClick={() => dispatch(updateCategory(14))}>
                                                    <a href="#">
                                                        <img src={colorizer} />
                                                        <p>future-architecture</p>
                                                    </a>
                                                </li> */}
          <li onClick={() => dispatch(updateCategory(15))}>
            <a href="#">
              <img src={contemporaryarchitecture} />
              <p>contemporary-architecture</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(17))}>
            <a href="#">
              <img src={pop_art} />
              <p>paper-art</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(19))}>
            <a href="#">
              <img src={d_character} />
              <p>3d-character</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(20))}>
            <a href="#">
              <img src={d_origami} />
              <p>3d-origami</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(22))}>
            <a href="#">
              <img src={impressionism} />
              <p>impressionism</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(23))}>
            <a href="#">
              <img src={abstract} />
              <p>abstract</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(24))}>
            <a href="#">
              <img src={renaissance} />
              <p>renaissance</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(25))}>
            <a href="#">
              <img src={old_drawing} />
              <p>old-drawing</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(26))}>
            <a href="#">
              <img src={anime_portrait} />
              <p>anime-portrait</p>
            </a>
          </li>
          <li onClick={() => dispatch(updateCategory(27))}>
            <a href="#">
              <img src={cyberpunk} />
              <p>cyberpunk</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(28))}>
            <a href="#">
              <img src={fantasy_world} />
              <p>fantasy-world</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(29))}>
            <a href="#">
              <img src={dream} />
              <p>dream</p>
            </a>
          </li>

          <li onClick={() => dispatch(updateCategory(30))}>
            <a href="#">
              <img src={colorizer} />
              <p>colorizer</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default StyleModulePopup;
